import MuseumsListTile from "./MuseumsListTile";

export default MuseumsListTile;
